import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonUsualText from '../../../common-components/common-usual-text';

const Algoritm = () => {
    return (
        <div className="linkbuilder-algoritm__content-wrap">
            <FullWrapper smallPaddings={true} isMargin={false}>
                <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
                    <div className="linkbuilder-algoritm__content">
                        <CommonTitle>Алгоритм ИИ</CommonTitle>
                        <CommonUsualText>
                            Сервис работает благодаря двум нейронным сетям:
                        </CommonUsualText>

                        <ScrollAnimation
                            animateIn="fadeInUp"
                            offset={100}
                            animateOnce={true}
                            duration={1}
                            className="linkbuilder-algoritm__grid"
                        >
                            <div className="linkbuilder-algoritm-item linkbuilder-algoritm-item--small linkbuilder-algoritm-item--left">
                                <b>1-ая нейросеть</b>
                                <br /> анализирует код и тексты сайта
                            </div>

                            <div className="linkbuilder-algoritm-item">
                                <img
                                    src="/images/pic/linkbuilder/algoritm.png"
                                    alt=""
                                    loading="lazy"
                                />
                            </div>

                            <div className="linkbuilder-algoritm-item linkbuilder-algoritm-item--small linkbuilder-algoritm-item--right">
                                <b>2-ая нейросеть</b>
                                <br /> анализирует изображения и скриншоты
                            </div>
                        </ScrollAnimation>

                        <div className="linkbuilder-algoritm__bottom">
                            После их работы пользователь в личном кабинете получает список из
                            нескольких тысяч сайтов — <b>Research list</b>
                        </div>
                    </div>
                </ScrollAnimation>
            </FullWrapper>
        </div>
    );
};

export default Algoritm;
